const PATH = '/builder/sso_providers';

export const ssoProviders = ($http: HttpApi) => ({
  list: (params: HttpParams['params'] = {}) => $http.$get(PATH, { params }),
  create: (data: HttpParams['body']) => $http.$post(PATH, { body: data }),
  update: (id: string, data: HttpParams['body']) => $http.$patch(`${PATH}/${id}`, { body: data }),
});
